import { SelectSearchComponent } from './select-search.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';


@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
  ],
  declarations: [
    SelectSearchComponent
  ],
  exports: [
    SelectSearchComponent
  ]
})
export class SelectSearchModule { }
